var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", { attrs: { page: _vm.page } }),
      _c("filter-manager", {
        ref: "filter",
        attrs: {
          filters: _vm.filterManagerConfig.basic.concat(
            _vm.filterManagerConfig.advanced
          ),
          "open-advanced": true
        },
        on: {
          academicYear: _vm.onChangeAcademicYear,
          center: _vm.onChangeCenters,
          month: _vm.onChangeMonth,
          provider: _vm.onChangeProvider,
          search: _vm.onSearchHandler,
          specialist: _vm.onChangeSpecialist
        },
        model: {
          value: _vm.filterModel,
          callback: function($$v) {
            _vm.filterModel = $$v
          },
          expression: "filterModel"
        }
      }),
      _c("custom-separator", {
        staticClass: "pt-3",
        attrs: { text: "Resultado de Referidos" }
      }),
      _vm.specialistInfoData && _vm.hasResults
        ? _c(
            "div",
            { staticClass: "mt-4" },
            [
              _c(
                "div",
                { staticClass: "specialist-container mb-3 pb-2 mt-3" },
                [
                  _c("div", { staticClass: "row py-3" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center col-md-3" },
                      [
                        _c("div", { staticClass: "d-flex flex-column" }, [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-start" },
                            [
                              _c("em", {
                                staticClass:
                                  "title-icon font-18 color-primary-1 fa fa-file mr-1"
                              }),
                              _c("div", { staticClass: "d-flex flex-column" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "color-secondary-6 font-14 ml-1"
                                  },
                                  [_vm._v(" Cantidad de Servicio ")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "color-black font-32 font-weight-bold"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.specialistInfoData.total) +
                                        " "
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-3 d-flex align-items-center justify-content-center",
                        class: { "col-md-6": !_vm.canShowStatus }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-center indicator-size",
                            class: _vm.getPeriodIndicatorClass
                          },
                          [
                            _c("span", [
                              _vm._v(
                                " " + _vm._s(_vm.getPeriodIndicatorLabel) + " "
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm.canShowStatus
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-md-3 d-flex align-items-center justify-content-center"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text-center indicator-size",
                                class: _vm.getPeriodIndicatorStatusClass
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.getPeriodIndicatorStatusLabel)
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-3 d-flex justify-content-end align-items-center"
                      },
                      [
                        _vm.canFinalizePeriod
                          ? _c(
                              "action-button",
                              {
                                attrs: {
                                  i: _vm.getButtonIcon,
                                  text: "Guardar",
                                  variant:
                                    "outline-success px-4 transparent-color bg-transparent"
                                },
                                on: { click: _vm.doAction }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.getActionButtonLabel) + " "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._l(_vm.results, function(item, index) {
                return _c(
                  "div",
                  { key: "visit-registry" + index },
                  [
                    _c(
                      "custom-callout",
                      {
                        staticClass: "mb-3 custom-callout",
                        attrs: {
                          "border-color": _vm.getBorderColor,
                          "show-edition": item.isOpen
                        },
                        scopedSlots: _vm._u(
                          [
                            item.isOpen
                              ? {
                                  key: "edition",
                                  fn: function() {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "info-panel" },
                                        [
                                          _c(
                                            "b-tabs",
                                            {
                                              attrs: {
                                                "active-nav-item-class":
                                                  "mipe-tab font-weight-bold text-green active-nav-item-custom",
                                                "active-tab-class": "",
                                                "content-class": "mt-3",
                                                "nav-class":
                                                  "custom-nav-container",
                                                "no-nav-style": true
                                              },
                                              model: {
                                                value: _vm.tabIndex,
                                                callback: function($$v) {
                                                  _vm.tabIndex = $$v
                                                },
                                                expression: "tabIndex"
                                              }
                                            },
                                            [
                                              _c(
                                                "b-tab",
                                                {
                                                  attrs: {
                                                    active: "",
                                                    title:
                                                      "Información Adicional"
                                                  }
                                                },
                                                [
                                                  item.isEducativeService
                                                    ? _c(
                                                        "educative-additional-info",
                                                        {
                                                          attrs: {
                                                            "assignment-end-date": _vm.dateFormat(
                                                              item.assignmentEndDate
                                                            ),
                                                            "assignment-start-date": _vm.dateFormat(
                                                              item.assignmentStartDate
                                                            ),
                                                            value:
                                                              item.educationServiceInfo ||
                                                              {}
                                                          }
                                                        }
                                                      )
                                                    : _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "additional-info",
                                                            {
                                                              attrs: {
                                                                data: item
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "b-tab",
                                                {
                                                  attrs: {
                                                    active: _vm.tabIndex === 1,
                                                    title: "Detalle de Visitas"
                                                  }
                                                },
                                                [
                                                  _c("visit-details", {
                                                    attrs: { data: item.visits }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "b-tab",
                                                {
                                                  attrs: {
                                                    title:
                                                      "Información de Lugar de Servicio"
                                                  }
                                                },
                                                [
                                                  _c("location-service-info", {
                                                    attrs: { data: item }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              : null
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-1 col-sm-12 icon-container"
                            },
                            [
                              _c("div", { staticClass: "toggle-icon" }, [
                                _c("em", {
                                  class: _vm.toggleClass(item.isOpen),
                                  on: {
                                    click: () => {
                                      _vm.tabIndex = 0
                                      _vm.onToggleAdditionalInfo(item, index)
                                    }
                                  }
                                })
                              ]),
                              _c("div", { staticClass: "separator-line" })
                            ]
                          ),
                          !item.isEducativeService
                            ? _c(
                                "div",
                                {
                                  staticClass: "col-md-2 col-sm-12 col-spacing"
                                },
                                [
                                  _c("div", { staticClass: "legend font-14" }, [
                                    _vm._v(" Número de Referido: ")
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "font-weight-normal text-black"
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.referralNumber) + " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "col-md-2 col-sm-12 col-spacing"
                                },
                                [
                                  _c("div", { staticClass: "legend font-14" }, [
                                    _vm._v(" Número de Solicitud: ")
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "font-weight-normal text-black"
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.referralNumber) + " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                          _c(
                            "div",
                            { staticClass: "col-md-2 col-sm-12 col-spacing" },
                            [
                              _c("div", { staticClass: "legend font-14" }, [
                                _vm._v(" Servicio: ")
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "font-weight-normal text-black"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.disciplineDescription) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-3 col-sm-12 col-spacing" },
                            [
                              _c("div", { staticClass: "legend font-14" }, [
                                _vm._v(" Estudiante: ")
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "font-weight-normal text-black"
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(item.studentFullName) + " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-2 col-sm-12 col-spacing service-place-spacing"
                            },
                            [
                              _c("div", { staticClass: "legend font-14" }, [
                                _vm._v(" SIE: ")
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "font-weight-normal text-black"
                                },
                                [_vm._v(" " + _vm._s(item.studentSieId) + " ")]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-1 col-sm-12 col-spacing service-place-spacing"
                            },
                            [
                              _c("div", { staticClass: "legend font-14" }, [
                                _vm._v(" Conteo: ")
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "font-weight-normal text-black"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.visits?.length
                                          ? item.visits.length
                                          : "-"
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-2 col-sm-12 col-spacing d-flex align-items-center"
                            },
                            [
                              _c("dropdown", {
                                staticClass: "actions-dropdown",
                                attrs: {
                                  id: "dropdownActions",
                                  "data-item": { item, index },
                                  items: _vm.actionItems,
                                  title: " Acciones "
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]
                    ),
                    item.hasErrorFlag
                      ? _c(
                          "div",
                          { staticClass: "visit-error-container" },
                          _vm._l(item.errorMessages, function(
                            errorMessage,
                            errorIndex
                          ) {
                            return _c("error", {
                              key: `validation-container-visit` + errorIndex,
                              attrs: {
                                message: errorMessage,
                                variant: "no-border"
                              }
                            })
                          }),
                          1
                        )
                      : _vm._e(),
                    _vm.isInterventionPlanNotSubmited(item)
                      ? _c(
                          "div",
                          { staticClass: "visit-error-container" },
                          [
                            _c("error", {
                              attrs: {
                                message:
                                  "No cuenta con un plan de intervención. Favor de registrar un plan de intervencion antes de finalizar periodo.",
                                variant: "no-border"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm.results != null && _vm.results.length === 0
        ? _c("custom-result-not-found")
        : _vm._e(),
      _vm.pagination.totalRecords > _vm.pageSize
        ? _c("pagination", {
            attrs: { data: _vm.pagination, "show-text": "" },
            on: { "pagination-go-page": _vm.goToPageHandler }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }